import { useState } from "react";
import { useDispatch } from "react-redux";
import css from "./BalanceTopupModal.module.css";
import { generateBalanceTopupInvoice } from "../../../redux/tariffs/operations.js";
import { showToast } from "../../../utils/showToast.js";
import LoaderSvg from "../../Loader/LoaderSvg.jsx";
import { useCan } from "../../../utils/permissions.js";
import ModalCloseIcon from "../../sharedComponents/ModalCloseIcon/ModalCloseIcon";

export default function BalanceTopupModal({ onClose, selectedService }) {
  const dispatch = useDispatch();
  //   const currentTariffInfo = useSelector(selectTariffsInfo);
  const workshopId = selectedService?.id;

  const [amount, setAmount] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const can = useCan();

  const handleSubmit = () => {
    if (!can("invoices", "create")) {
      showToast(
        {
          title: "Недостатньо прав для поповнення балансу",
          description:
            "Зверніться до власника автосервісу для проведення оплати.",
        },
        "error"
      );
      return;
    }

    const parsedAmount = parseFloat(amount);

    if (!parsedAmount || parsedAmount < 500) {
      showToast("Введіть коректну суму поповнення (мінімум 500 грн)", "error");
      return;
    }

    if (!workshopId) {
      showToast("Щось пішло не так! Спробуйте пізніше.", "error");
      return;
    }

    const invoiceData = {
      workshop_id: workshopId,
      amount: parsedAmount,
      currency: "UAH",
      success_url: "https://app.crmmech.com/login",
      cancel_url: "https://app.crmmech.com/login",
    };

    setIsLoading(true);

    dispatch(generateBalanceTopupInvoice(invoiceData))
      .unwrap()
      .then(res => {
        const pageUrl = res.payment_link;
        if (!pageUrl) {
          showToast("Щось пішло не так! Спробуйте пізніше.", "error");
          return;
        }
        window.location.href = pageUrl;
        onClose();
      })
      .catch(() => {
        showToast(
          {
            title: "Щось пішло не так",
            description: "Будь ласка, спробуйте ще раз.",
          },
          "error"
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className={css.modal}>
      {isLoading ? (
        <LoaderSvg />
      ) : (
        <>
          <ModalCloseIcon onClose={onClose} />

          <h2 className={css.title}>Поповнити рахунок</h2>
          <p className={css.subtitle}>
            Для поповнення рахунку в сервісі CRMMech вкажіть суму до оплати.
          </p>

          <div className={css.formWrapper}>
            <div className={css.inputRow}>
              <label className={css.label}>Сума поповнення:</label>
              <div className={css.inputWithCurrency}>
                <input
                  type="number"
                  min="500"
                  className={css.input}
                  value={amount}
                  onChange={e => setAmount(e.target.value)}
                  onKeyDown={e => e.key === "Enter" && handleSubmit()}
                  placeholder="0"
                  autoFocus
                />
                <span className={css.currency}>грн</span>
              </div>
            </div>

            <div className={css.btnRow}>
              <button
                type="button"
                className={css.submitBtn}
                onClick={handleSubmit}
              >
                Поповнити рахунок
              </button>
              <a
                // href="https://app.crmmech.com/billing"
                target="_blank"
                rel="noreferrer"
                className={css.termsLink}
              >
                Умови використання
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
